/**
 * NewsItemView view component.
 * @module components/theme/View/NewsItemView
 */
import PropTypes from 'prop-types';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import { FormattedDate, Button } from '@plone/volto/components';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';

const NewsItemView = ({ content }) => {
  return (
    <div id="page-document" className="view-wrapper newsitem-view">
      <UniversalLink className="content" href="/noticias">
        Volver a Noticias
      </UniversalLink>
      {/* <div className="dates">
        {content?.effective ? (
          <span className="day">
            <FormattedDate date={content?.effective} />{' '}
          </span>
        ) : (
          <span className="day">No date</span>
        )}{' '}
        {content?.head_title && (
          <span className="head-title"> {content?.head_title}</span>
        )}
      </div> */}

      <RenderBlocks content={content} />
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
NewsItemView.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    text: PropTypes.shape({
      data: PropTypes.string,
    }),
  }).isRequired,
};

export default NewsItemView;
